import API from "../../../services/api";
import {
  previewReport,
  downloadReport,
  getHistory,
  downloadArtifact,
  triggerBlobDownload,
} from "../statutory/statutoryReportsApi";

export const ESI_REPORT_KEY = "esi_monthly";

export function previewEsiReport(body, options = {}) {
  return previewReport({ report_key: ESI_REPORT_KEY, ...body }, options);
}

export function downloadEsiReport(body) {
  return downloadReport({ report_key: ESI_REPORT_KEY, ...body });
}

export function getEsiHistory(limit = 100) {
  return getHistory({ reportKey: ESI_REPORT_KEY, limit });
}

export { downloadArtifact, triggerBlobDownload };

export async function loadFilterOptions() {
  const [departments, designations, locations] = await Promise.all([
    API.get("/setup/departments").then((r) => r.data || []).catch(() => []),
    API.get("/setup/designations").then((r) => r.data || []).catch(() => []),
    API.get("/setup/locations").then((r) => r.data || []).catch(() => []),
  ]);
  return { departments, designations, locations };
}
